var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.windowResize.width > 1023)?_c('Balances'):_c('RedirectFromManager')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }